import { Flex, useMultiStyleConfig } from "@chakra-ui/react";
import React from "react";

import { INavigationHeaderProps } from "adminComponents/molecules/NavigationHeader";
import { TeacherNotificationSettingsForm } from "adminComponents/organisms/TeacherNotificationSettingsForm";
import { TeacherAccountTemplate } from "adminComponents/templates/TeacherAccountTemplate";
import { UserRecurringNotificationSettings } from "links/lib/types";

export interface IProps {
  navigationData: INavigationHeaderProps;
  isLoading: boolean;
  isFormLoading: boolean;
  settings?: UserRecurringNotificationSettings;
  handleSubmit: (settings: UserRecurringNotificationSettings) => void;
}

export const TeacherNotificationSettingsScreen: React.FC<IProps> = ({
  navigationData,
  settings,
  isLoading,
  isFormLoading,
  handleSubmit,
}) => {
  const styles = useMultiStyleConfig("AdminTeacherAccountScreen", {});

  return (
    <TeacherAccountTemplate
      navigationData={navigationData}
      isLoading={isLoading}
    >
      <Flex sx={styles.contentContainer}>
        {settings && (
          <TeacherNotificationSettingsForm
            handleSubmit={handleSubmit}
            initialSettings={settings}
            isLoading={isFormLoading}
          />
        )}
      </Flex>
    </TeacherAccountTemplate>
  );
};
